import React from 'react';
import { Layout, Typography } from 'antd';
import { 
  CopyrightOutlined
} from '@ant-design/icons';
import './Footer.css';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

const Footer: React.FC = () => {
  const footerLinks = [
    { label: 'About', url: 'https://www.toptenhow.com/about' },
    { label: 'Contact', url: 'https://www.toptenhow.com/about' },
    { label: 'Privacy Policy', url: 'https://www.toptenhow.com/privacy-policy' },
    { label: 'Terms & Conditions', url: 'https://www.toptenhow.com/terms-conditions' }
  ];

  return (
    <AntFooter className="app-footer">
      <div className="footer-content">
        {/* 左侧链接区域 */}
        <div className="footer-links-section">
          <div className="footer-links">
            {footerLinks.map((link, index) => (
              <Link 
                key={index}
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-link"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
        
        {/* 右侧版权信息 */}
        <div className="footer-copyright-section">
          <div className="company-info">
            <Text className="company-name">INNOTREND COMMERCE HK LIMITED</Text>
            <Text className="company-number">COMPANY NUMBER: 2802528</Text>
          </div>
          <div className="copyright-info">
            <CopyrightOutlined />
            <Text>2025 TopTenHow</Text>
          </div>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;
